import { useState, useEffect } from "react";
import styles from "./TabIconSwitcher.module.css"

const TabIconSwitcher = ({ tabs, selected, onSelect = () => { }, style, theme, names = true }) => {

    const [_index, setIndex] = useState(selected ?? 0);

    useEffect(() => {
        setIndex(selected);
    }, [selected])

    const handleSelect = (index) => {
        setIndex(index);
        onSelect(index);
    }


    return (
        <div className={`${styles.container} ${theme === 'dark' ? styles.dark : ''}`} style={style}>
            {tabs.map((tab, index) => {
                return (
                    <div key={index} className={`${styles.icon} ${_index === index ? styles.active : ''} ${names ? styles.names : ''} ${tab.hidden ? styles.hidden : ''}`} onClick={() => handleSelect(index)}>
                        <span>
                            {tab.icon}
                            {tab.badge &&
                                <div className={styles.badge}>{tab.badge}</div>
                            }
                        </span>
                        {names &&
                            <div className={styles.name}>{tab.name}</div>
                        }
                    </div>
                )
            })}
        </div>
    )

}

export default TabIconSwitcher;